import axiosInstance from '@/api/axiosInstance';
import axios from 'axios';
import { showErrorToast } from '@/utils/toastManager';

export const getPaymentMethods = async () => {
  // API is not ready yet, return empty array
  return [];
};

// Get payment cards
export const getPaymentCards = async () => {
  const response = await axiosInstance.get('/users/me/payment-cards');
  return response.data;
};

// Set default payment card
export const setDefaultPaymentCard = async (cardId) => {
  const response = await axiosInstance.put(`/users/me/payment-cards/${cardId}/default`);
  return response.data;
};

// Delete payment card
export const deletePaymentCard = async (cardId) => {
  const response = await axiosInstance.delete(`/users/me/payment-cards/${cardId}`);
  return response.data;
};

// Veritrans 4G Token API
export const getVeritransToken = async (cardData) => {
  const { cardNumber, cardExpire, securityCode, cardholderName, tokenApiKey, lang = 'ja' } = cardData;

  try {
    const response = await axios.post('https://api3.veritrans.co.jp/4gtoken', {
      card_number: cardNumber,
      card_expire: cardExpire, // Should be in MM/YY format like "08/28"
      security_code: securityCode,
      cardholder_name: cardholderName,
      token_api_key: tokenApiKey,
      lang
    }, {
      headers: {
        'Content-Type': 'application/json',
      }
    });

    return response.data;
  } catch (error) {
    console.error('Veritrans token error:', error);

    // Handle 400 errors with specific error messages
    if (error.response?.status === 400 && error.response?.data?.message) {
      showErrorToast(error.response.data.message);
    }

    throw error;
  }
};
